export enum Issuer {
  HMAC = "hmac",
  JWT = "jwt",
  NONE = "none"
}

export type HmacCredentials = {
  api_key: string;
  signature: string;
  timestamp: string;
  user_id: string;
};

export type JwtCredentials = {
  token: string;
};

export type Auth = {
  issuer: Issuer;
  isAuthenticated: boolean;
  isLoading: boolean;
  credentials: HmacCredentials | JwtCredentials | null;
};
